import { I } from '@angular/cdk/keycodes';
import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { features } from 'process';
import { Subscription } from 'rxjs';
import { Features } from 'src/app/models/features.enum';
import { DashboardService } from 'src/app/service/dashboard.service';
import { SettingsService } from 'src/app/service/settings-service';
import { UtilityService } from 'src/app/service/utility.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { dashboardTourValues } from 'src/environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { Globals } from 'src/app/service/global';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-meetings',
  templateUrl: './meetings.component.html',
  styleUrls: ['./meetings.component.css']
})
export class MeetingsComponent implements OnInit, OnDestroy {
  rightProvided = false;
  mediaSub!: Subscription;
  deviceXs!: boolean;
  deviceSm!: boolean;
  deviceMd!: boolean;
  deviceLg!: boolean;
  deviceXl!: boolean;
  meetingJSON: any;
  dashboardTourValues = dashboardTourValues;
  meetingCount=0;
  constructor(private readonly breakpointObserver: BreakpointObserver,public utils:UtilityService,public sideNavService : SideNavServiceService,public mediaObserver : MediaObserver,private dashboard:DashboardService,private settings:SettingsService,private globals: Globals) {
    var meetingJSON = {
      "delay": "10",
      "displayConfig": this.globals.settingValuesList.UPCOMING_MEETING_CONF,
      // "meetingStatus": [
      //   18,648
      // ],
      "startDelay": "60",
      "userId": this.globals.userId,
      "startDate": "",
      "endDate": "",
      "visitorTimeZone": this.globals.vTimeZone,
      "filterCol": ""
    }
    dashboard.documentMeetingCount(meetingJSON).subscribe(data =>{
 
      this.meetingCount=data.totalCount;
    })
   }
  
   constructTitle(state:any, parent:any):any {
    var data = [];
    if(parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if(state && parent) {
      data.push(... this.constructTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;
  remoDoCheckExecution = false
  // rightProvided = false;
  iconSender = 'today'

  shown: 'native' | 'hover' | 'always' = 'native';

  ngOnInit(){
  this.mediaSub = this.breakpointObserver.observe([
    Breakpoints.XSmall,
    Breakpoints.Small,
    Breakpoints.Medium,
    Breakpoints.Large,
    Breakpoints.XLarge
  ]).subscribe(result => {
    const breakpoints = result.breakpoints;

    this.deviceXs = breakpoints[Breakpoints.XSmall] || false;
    this.deviceSm = breakpoints[Breakpoints.Small] || false;
    this.deviceMd = breakpoints[Breakpoints.Medium] || false;
    this.deviceLg = breakpoints[Breakpoints.Large] || false;
    this.deviceXl = breakpoints[Breakpoints.XLarge] || false;
  });
  }

  ngDoCheck(){
    if(this.sideNavService.returnExpandFullScreeBooleanSetter() && (this.deviceLg || this.deviceXl)){
      if(document.getElementsByClassName('example-sidenav')[0] != undefined){
        document.getElementsByClassName('example-sidenav')[0].classList.add('hide-navigation-bar-large-screen');
      }
      if(document.getElementsByClassName('header-container-main')[0] != undefined){
        document.getElementsByClassName('header-container-main')[0].classList.add('hide-navigation-bar-large-screen')
      }
      if(document.getElementsByClassName('mat-sidenav-content')[0] != undefined){
        document.getElementsByClassName('mat-sidenav-content')[0].setAttribute('style','margin-left : 0px')
      }
      if(document.getElementsByClassName('footer')[0] != undefined){
        document.getElementsByClassName('footer')[0].classList.add('hide-navigation-bar-large-screen')
      }
    }
    else if(!this.sideNavService.returnExpandFullScreeBooleanSetter() && (this.deviceLg || this.deviceXl)){
      if(document.getElementsByClassName('example-sidenav')[0] != undefined){
        document.getElementsByClassName('example-sidenav')[0].classList.remove('hide-navigation-bar-large-screen');
      }
      if(document.getElementsByClassName('header-container-main')[0] != undefined){
        document.getElementsByClassName('header-container-main')[0].classList.remove('hide-navigation-bar-large-screen')
      }
      if(document.getElementsByClassName('mat-sidenav-content')[0] != undefined){
        document.getElementsByClassName('mat-sidenav-content')[0].setAttribute('style','margin-left : 65px')
      }
      if(document.getElementsByClassName('footer')[0] != undefined){
        document.getElementsByClassName('footer')[0].classList.remove('hide-navigation-bar-large-screen')
      }
    }

    if(this.sideNavService.returnExpandFullScreeBooleanSetter() && (!this.deviceLg && !this.deviceXl)){
      if(document.getElementsByClassName('example-sidenav')[0] != undefined){
        document.getElementsByClassName('example-sidenav')[0].classList.add('hide-navigation-bar-large-screen');
      }
      if(document.getElementsByClassName('header-container-main')[0] != undefined){
        document.getElementsByClassName('header-container-main')[0].classList.add('hide-navigation-bar-large-screen')
      }
      if(document.getElementsByClassName('mat-sidenav-content')[0] != undefined){
        document.getElementsByClassName('mat-sidenav-content')[0].setAttribute('style','margin-left : 0px')
      }
      if(document.getElementsByClassName('layout-footer')[0] != undefined){
        document.getElementsByClassName('layout-footer')[0].classList.add('hide-navigation-bar-large-screen')
      }
    }
    else if(!this.sideNavService.returnExpandFullScreeBooleanSetter() && (!this.deviceLg && !this.deviceXl)){
      if(document.getElementsByClassName('example-sidenav')[0] != undefined){
        document.getElementsByClassName('example-sidenav')[0].classList.remove('hide-navigation-bar-large-screen');
      }
      if(document.getElementsByClassName('header-container-main')[0] != undefined){
        document.getElementsByClassName('header-container-main')[0].classList.remove('hide-navigation-bar-large-screen')
      }
      if(document.getElementsByClassName('mat-sidenav-content')[0] != undefined){
        document.getElementsByClassName('mat-sidenav-content')[0].setAttribute('style','margin-left : 0px')
      }
      if(document.getElementsByClassName('layout-footer')[0] != undefined){
        document.getElementsByClassName('layout-footer')[0].classList.remove('hide-navigation-bar-large-screen')
      }
    }
    
  }

  ngOnDestroy(){
    this.mediaSub.unsubscribe();
    this.sideNavService.expandFullScreenBooleanSetter(false,'','')
    if(this.sideNavService.returnExpandFullScreeBooleanSetter() && (this.deviceLg || this.deviceXl)){
      document.getElementsByClassName('example-sidenav')[0]?.classList.add('hide-navigation-bar-large-screen');
      document.getElementsByClassName('header-container-main')[0]?.classList.add('hide-navigation-bar-large-screen')
      document.getElementsByClassName('mat-sidenav-content')[0]?.setAttribute('style','margin-left : 0px')
      document.getElementsByClassName('footer')[0]?.classList.add('hide-navigation-bar-large-screen')
    }
    else if(!this.sideNavService.returnExpandFullScreeBooleanSetter() && (this.deviceLg || this.deviceXl)){
      document.getElementsByClassName('example-sidenav')[0]?.classList.remove('hide-navigation-bar-large-screen');
      document.getElementsByClassName('header-container-main')[0]?.classList.remove('hide-navigation-bar-large-screen')
      document.getElementsByClassName('mat-sidenav-content')[0]?.setAttribute('style','margin-left : 65px')
      document.getElementsByClassName('footer')[0]?.classList.remove('hide-navigation-bar-large-screen')
    }

    if(this.sideNavService.returnExpandFullScreeBooleanSetter() && (!this.deviceLg && !this.deviceXl)){
      document.getElementsByClassName('example-sidenav')[0]?.classList.add('hide-navigation-bar-large-screen');
      document.getElementsByClassName('header-container-main')[0]?.classList.add('hide-navigation-bar-large-screen')
      document.getElementsByClassName('mat-sidenav-content')[0]?.setAttribute('style','margin-left : 0px')
      document.getElementsByClassName('layout-footer')[0]?.classList.add('hide-navigation-bar-large-screen')
    }
    else if(!this.sideNavService.returnExpandFullScreeBooleanSetter() && (!this.deviceLg && !this.deviceXl)){
      document.getElementsByClassName('example-sidenav')[0]?.classList.remove('hide-navigation-bar-large-screen');
      document.getElementsByClassName('header-container-main')[0]?.classList.remove('hide-navigation-bar-large-screen')
      document.getElementsByClassName('mat-sidenav-content')[0]?.setAttribute('style','margin-left : 0px')
      document.getElementsByClassName('layout-footer')[0]?.classList.remove('hide-navigation-bar-large-screen')
    }
    this.remoDoCheckExecution = false
  }

}
